import React from 'react';
import { useTranslation } from 'react-i18next';

const STATUS_CONFIG = {
  belum: {
    labelKey: 'stBelum',
    pill: 'bg-red-50 text-red-700 border-red-200 dark:bg-red-950/60 dark:text-red-300 dark:border-red-800/70',
    dot: 'bg-red-500 dark:bg-red-400',
  },
  separa: {
    labelKey: 'stSepara',
    pill: 'bg-amber-50 text-amber-800 border-amber-200 dark:bg-amber-950/60 dark:text-amber-300 dark:border-amber-800/70',
    dot: 'bg-amber-500 dark:bg-amber-400',
  },
  lunas: {
    labelKey: 'stLunas',
    pill: 'bg-emerald-50 text-emerald-700 border-emerald-200 dark:bg-emerald-950/60 dark:text-emerald-300 dark:border-emerald-800/70',
    dot: 'bg-emerald-500 dark:bg-emerald-400',
  },
  pending: {
    labelKey: 'stPending',
    pill: 'bg-amber-50 text-amber-800 border-amber-200 dark:bg-amber-950/60 dark:text-amber-300 dark:border-amber-800/70',
    dot: 'bg-amber-500 dark:bg-amber-400',
  },
  lulus: {
    labelKey: 'stLulus',
    pill: 'bg-emerald-50 text-emerald-700 border-emerald-200 dark:bg-emerald-950/60 dark:text-emerald-300 dark:border-emerald-800/70',
    dot: 'bg-emerald-500 dark:bg-emerald-400',
  },
  tolak: {
    labelKey: 'stTolak',
    pill: 'bg-red-50 text-red-700 border-red-200 dark:bg-red-950/60 dark:text-red-300 dark:border-red-800/70',
    dot: 'bg-red-500 dark:bg-red-400',
  },
};

export default function StatusPill({ status, className = '' }) {
  const { t } = useTranslation();
  const cfg = STATUS_CONFIG[status] || STATUS_CONFIG.pending;
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-semibold border transition-colors ${cfg.pill} ${className}`}
      data-testid={`status-pill-${status}`}
    >
      <span className={`h-2 w-2 rounded-full ${cfg.dot}`} />
      {t(cfg.labelKey)}
    </span>
  );
}
